import { createContext } from 'react';

const FeatureToggleContext = createContext({});
FeatureToggleContext.displayName = 'FeatureToggleContext';

export default FeatureToggleContext;
